import React, { Component } from 'react';
import { ButtonToolbar, Button, Table, Row, Col, Grid } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { SetOfDayTypesForm } from './SetOfDayTypesForm';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { SetOfDayTypesCommand } from '../commands/SetOfDayTypesCommand';
import { DayTypesCommand } from '../commands/DayTypesCommand';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchBar } from '../../SearchBar';
import { SearchHelper } from '../../helpers/SearchHelper';
import { TitleRow } from '../../TitleRow';
import { TableButton } from '../../TableButton';

export class SetOfDayTypes extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    constructor(props) {
        super(props);

        this.state = {
            commands: {
                setOfDayTypes: new SetOfDayTypesCommand(),
                dayTypes: new DayTypesCommand()
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 10,
                filter: ""
            },
            dependencies: {
                dayTypes: []
            },
            form: {
                title: undefined,
                setOfDayTypes: undefined,
                original: undefined
            },
            actions: {
                isLoading: true,
                isLoadingDayTypes: true,
                isUpdating: false,
                isDeleting: false
            },
            render: {
                sort: {
                    property: "name",
                    type: "ascending"
                }
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);

        this.getSetOfDayTypes();
        this.getDayTypes();
    }

    // ---------------------------

    getSetOfDayTypes(resetData = false) {
        if (resetData) {
            const { table } = this.state;

            table.data = [];

            this.setState({
                table: table
            });
        }

        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;
        
        actions.isLoading = true;
        commands.setOfDayTypes.getAll(
            selectedProviderId,
            (a) => this.listSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    getDayTypes() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { dependencies, actions } = this.state;

        dependencies.dayTypes = [];
        actions.isLoadingDayTypes = true;

        this.setState({
            dependencies: dependencies,
            actions: actions
        });

        const { commands } = this.state;
        commands.dayTypes.getAll(
            selectedProviderId,
            (a) => this.listDayTypesSuccessCallback(a),
            (a) => this.listDayTypesErrorCallback(a)
        );
    }

    // ---------------------------

    listSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    listDayTypesSuccessCallback(result) {
        const { dependencies, actions } = this.state;

        actions.isLoadingDayTypes = false;
        dependencies.dayTypes = result;

        // Update table
        this.setState({
            dependencies: dependencies,
            actions: actions
        });
    }

    listErrorCallback(messageReceived) {
        const { table, actions, message } = this.state;

        actions.isLoading = false;
        table.data = [];
        table.page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    listDayTypesErrorCallback(messageReceived) {
        const { dependencies, actions, message } = this.state;

        actions.isLoadingDayTypes = false;
        dependencies.dayTypes = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getSetOfDayTypes();
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onCreateClick() {
        const { form } = this.state;

        form.original = null;
        form.setOfDayTypes = {
            id: 0,
            name: "",
            dayTypes: [],
        };
        form.title = "Criar";

        this.setState({
            form: form
        });
    }

    onEditClick(data) {
        const { form } = this.state;

        form.original = data;
        form.setOfDayTypes = Object.assign({}, data);
        form.title = "Editar";

        this.setState({
            form: form
        });
    }

    onDeleteClick(setOfDayTypes) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o conjunto de tipos de dia "${setOfDayTypes.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    id: setOfDayTypes.id
                }
            }
        });
    }

    onSetOfDayTypesSave(setOfDayTypes) {
        const { commands, actions } = this.state;
        commands.setOfDayTypes.save(
            setOfDayTypes,
            (a) => this.operationSuccessCallback(a, "isUpdating"),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        actions.isUpdating = true;
        this.setState({
            actions: actions
        });

        this.onSetOfDayTypesExit();
    }

    onSetOfDayTypesExit() {
        this.setState({
            form: {
                title: undefined,
                setOfDayTypes: undefined,
                original: undefined,
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;
            commands.setOfDayTypes.delete(
                argument.id,
                (a) => this.operationSuccessCallback(a, "isDeleting"),
                (a) => this.operationErrorCallback(a, "isDeleting")
            );

            actions.isDeleting = true;
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // -----------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    onChangePage(page) {
        const { table } = this.state;

        table.page = page;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elements) {
        const { table } = this.state;

        table.elementsPerPage = elements;

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    // ---------------

    filterByDayType(value) {
        return value.map(v => v.name).join();
    }

    sortData(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if(undefined === aValue) {
            aValue = "";
        }

        if(undefined === bValue) {
            bValue = "";
        }

        if (aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if ("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // ---------------

    renderForm() {
        const { form, dependencies } = this.state;

        if (null === form.setOfDayTypes || undefined === form.setOfDayTypes) {
            return null;
        }

        return (
            <SetOfDayTypesForm title={form.title}
                setOfDayTypes={form.setOfDayTypes}
                dayTypes={dependencies.dayTypes}
                onSave={(a) => this.onSetOfDayTypesSave(a)}
                onHide={() => this.onSetOfDayTypesExit()} />
        );
    }

    renderLoading(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if (property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    renderTable(isWaiting) {
        const { table, render } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["name", "dayTypes"],
            callbackComparison: [{ "dayTypes": (a) => this.filterByDayType(a) }]
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered.sort((a, b) => this.sortData(render.sort, a, b))
            .slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <div className="table-loading">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th className="sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                        <th>Tipos de Dia</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody className={isWaiting ? "overlay" : ""}>
                                    {
                                        partialData.map((data, i) =>
                                            <tr key={`set-${i}`}>
                                                <td>{data.name}</td>
                                                <td>{data.dayTypes.map((dayType, j) => <li key={`set-${i}-dayType-${j}`}>{dayType.name}</li>)}</td>
                                                <td>
                                                    <ButtonToolbar className="pull-right">
                                                        <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.onEditClick(data)} />
                                                        <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteClick(data)} />
                                                    </ButtonToolbar>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>

                            <PaginationBuilder
                                currentPage={activePage}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={dataFiltered.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

                            {this.renderLoading(isWaiting)}
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { actions, message, dialog } = this.state;

        return (
            <div>
                <TitleRow title="Conjuntos de Tipos de Dia" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.onCreateClick()}>CRIAR</Button>
                        </ButtonToolbar>
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                {this.renderTable(actions.isLoading || actions.isUpdating || actions.isDeleting)}
                {this.renderForm()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/setOfDayTypes/SetOfDayTypes.js